import { render } from "./TeatroFooter.vue?vue&type=template&id=6db0e18a&scoped=true"
import script from "./TeatroFooter.vue?vue&type=script&lang=js"
export * from "./TeatroFooter.vue?vue&type=script&lang=js"

import "./TeatroFooter.vue?vue&type=style&index=0&id=6db0e18a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db0e18a"]])

export default __exports__